
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#798F8F","stroke-linecap":"round"}},[_c('path',{staticClass:"i-stroke",attrs:{"d":"M10.75 7.608 6.383 11.82l-.611 2.748 2.748-.61 4.368-4.213","stroke-linejoin":"round"}}),_c('path',{staticClass:"i-stroke_2",attrs:{"d":"M5.178 7.452a2.467 2.467 0 1 0 0-4.934 2.467 2.467 0 0 0 0 4.934Z"}}),_c('path',{staticClass:"i-stroke_3",attrs:{"d":"M15.089 5.259c-.593-.592-1.619-.527-2.292.147l-.61.61 2.146 2.145.61-.61c.673-.673.739-1.7.146-2.292Z","stroke-linejoin":"round"}}),_c('path',{staticClass:"i-stroke_4",attrs:{"d":"M1.567 9.893a3.86 3.86 0 0 1 1.498-1.765 4.167 4.167 0 0 1 2.286-.646 4.168 4.168 0 0 1 2.116.602"}})])])
          )
        }
      }
    